import React, { useEffect, useState } from 'react';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';

import { propTypes } from '../../util/types';

import css from './LandingPage.module.css';
import StaticPage from '../PageBuilder/StaticPage';
import { LayoutComposer } from '../PageBuilder/PageBuilder';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';
import TopbarSearchForm from '../../components/Topbar/TopbarSearchForm/TopbarSearchForm';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import CookieConsent from 'react-cookie-consent';

import { ReactComponent as CameraIcon } from '../../assets/icons/camera.svg';
import { ReactComponent as LensIcon } from '../../assets/icons/lens.svg';
import { ReactComponent as AudioIcon } from '../../assets/icons/microphone.svg';
import { ReactComponent as LightingIcon } from '../../assets/icons/bulb.svg';
import { ReactComponent as SupportIcon } from '../../assets/icons/tripod.svg';
import { ReactComponent as DroneIcon } from '../../assets/icons/drone.svg';
import { ReactComponent as AccessoriesIcon } from '../../assets/icons/sd-card.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/pin.svg';
import { ReactComponent as InstrumentIcon } from '../../assets/icons/guitar.svg';
import { ReactComponent as GripIcon } from '../../assets/icons/grip.svg';
import { ReactComponent as Monitor } from '../../assets/icons/monitor.svg';
import { ReactComponent as Effects } from '../../assets/icons/effects.svg';
import { ReactComponent as ProductionMaterial } from '../../assets/icons/productionMaterial.svg';

import searchCardBgImage from '../../assets/home_banner.jpg';
import we_have_insurance_banner_es from '../../assets/we_have_insurance_banner_es.png';
import we_have_insurance_banner_en from '../../assets/we_have_insurance_banner_en.png';
import we_have_insurance_banner_eu from '../../assets/we_have_insurance_banner_eu.png';

import { H2, H3, H5, ListingCard, NamedLink } from '../../components';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { handleToggleFavorites } from '../ListingPage/ListingPage.shared';
import CookieMananger from '../../components/ui-components/cookies/CookieMananger';
import UserOnboarding from '../AuthenticationPage/SignupForm/UserOnboarding/UserOnboarding';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import InquiryModal from './InquiryModal/InquiryModal';
import acctionCRMDate from '../../util/user/acctionCRMData';
import AlokaOnboarding from './AlokaOnboarding/AlokaOnboarding';
import basedPostUrlRequestLogedIn from '../../util/apiRequests/basedPostUrlRequestLogedIn';
import DiscountBanner from '../../components/DiscountBanner/DiscountBanner';
import Packs from '../../components/PackBanner/PackBanner';
import BuyPackPage from '../../components/PackBanner/BuyPackPage';

export const LandingPageComponent = props => {
  const [showNav, setShowNav] = useState(typeof window !== 'undefined' && !(window.scrollY == 0));
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const maxScroll = 18; // Ajusta esta cantidad según tu preferencia
      const shouldShowNav = scrollTop > maxScroll;

      setShowNav(shouldShowNav);
    };

    if (!window.scrollEventListener) {
      window.addEventListener('scroll', handleScroll);
      window.scrollEventListener = handleScroll;
    }

    return () => {
      if (window.scrollEventListener) {
        window.removeEventListener('scroll', window.scrollEventListener);
        window.scrollEventListener = null;
      }
    };
  }, []);

  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();

  const { mostPopularListings, queryInProgress, queryPopularError } = props;

  const handleSubmit = values => {
    const { history } = props;
    const topbarSearchParams = () => {
      let searchParams = { keywords: values?.keywords, dates: values?.dates };
      if (values?.location) {
        const { search, selectedPlace } = values?.location || {};
        const { origin, bounds } = selectedPlace || {};

        searchParams = {
          ...searchParams,
          address: search,
          bounds,
          origin,
        };
      }

      return searchParams;
    };

    const searchParams = {
      ...topbarSearchParams(),
    };

    history.push(
      `/${intl.locale}${createResourceLocatorString(
        'SearchPage',
        routeConfiguration,
        {},
        searchParams
      )}`
    );
  };

  const layoutAreas = `
    topbar
    main
    footer
  `;

  const categories = [
    'cameras',
    'lenses',
    'audio',
    'lighting',
    'supports',
    'drones',
    'accessories',
    'locations',
    'instruments',
    'grips',
    'monitors',
    'effects',
    'productionMaterial',
  ];

  const { currentUser, onUpdateFavorites, location, history } = props;

  const onToggleFavorites = handleToggleFavorites({
    currentUser,
    onUpdateFavorites,
    location,
    routes: routeConfiguration,
    history,
  });

  const handleAcceptCookies = () => {
    // Lógica para aceptar cookies
    // setStripeCookies();
    console.log('Cookies aceptadas');
  };

  const handleRejectCookies = () => {
    // Lógica para rechazar cookies
    console.log('Cookies rechazadas');
  };

  /*
  const setStripeCookies = () => {
    // Define las cookies necesarias de Stripe
    const stripeMidCookie = `__stripe_mid=valor-de-la-cookie-stripe-mid; expires=${new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)).toUTCString()}; path=/`;
    const stripeSidCookie = `__stripe_sid=valor-de-la-cookie-stripe-sid; expires=${new Date(Date.now() + (30 * 60 * 1000)).toUTCString()}; path=/`;
  
    // Establece las cookies
    document.cookie = stripeMidCookie;
    document.cookie = stripeSidCookie;
  };*/
  const imagelang = {
    en: we_have_insurance_banner_en,
    es: we_have_insurance_banner_es,
    eu: we_have_insurance_banner_eu,
  };

  const [homeQueryClosed, setHomeQueryClosed] = useState(false);

  useEffect(() => {
    const homeQuery = window.localStorage.getItem('homeQueryClosed');
    if (homeQuery === null) {
      setHomeQueryClosed(true);
    } else {
      setHomeQueryClosed(false);
    }
  }, []);
  const closeInquiryModal = () => {
    setHomeQueryClosed(false);
    window.localStorage.setItem('homeQueryClosed', 'true');
  };
  const currentInquiryModal = () => {
    if (homeQueryClosed) {
      return (
        <InquiryModal
          isOpen={homeQueryClosed}
          onClose={closeInquiryModal}
          onCloseInquirySend={closeInquiryModalAfterSending}
        />
      );
    }
    return;
  };
  const closeInquiryModalAfterSending = () => {
    window.localStorage.setItem('homeQueryClosed', 'true');
  };

  const handleclick = async () => {
    await basedPostUrlRequestLogedIn('/api/create-new-shipping-ticket', {
      transactionId: '6866a87b-d005-411e-a0ec-8b2332d6bcc7',
    });
  };
  return (
    <StaticPage>
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <Topbar as="header">
                <TopbarContainer
                  className={css.topbar}
                  desktopClassName={!showNav ? css.topbarDesktop : null}
                  hideSearchForm
                />
              </Topbar>
              <Main as="main" className={css.main}>
                {/* {currentInquiryModal()} */}
                <AlokaOnboarding user={currentUser} intl={intl} />
                {/* <button onClick={handleclick}> Click to send ticket</button> */}
                {/* <section>
                  <DiscountBanner />
                </section> */}
                <section>
                  <div
                    className={css.searchCard}
                    style={{ backgroundImage: `url('${searchCardBgImage}')` }}
                  >
                    <Link to="/seguro">
                      <img
                        className={css.we_have_insurance_banner}
                        src={`${imagelang[`${intl.locale}`]}`}
                      />
                    </Link>

                    <H2 className={css.title}>
                      {intl.formatMessage({ id: 'LandingPage.mainTitle' }, { br: <br /> })}
                    </H2>
                    <H3 className={css.subtitle}>
                      {intl.formatMessage({ id: 'LandingPage.mainSubtitle' })}
                    </H3>
                    <TopbarSearchForm
                      rootClassName={css.search}
                      className={css.searchLink}
                      onSubmit={handleSubmit}
                      rootButtonClass={css.searchButton}
                      showLabel
                    />
                  </div>
                </section>

                <section>
                  <h3 className={css.sectionTitle}>
                    {intl.formatMessage({ id: 'LandingPage.section.categoryTitle' })}
                  </h3>
                  {/* <UserOnboarding currentUser={currentUser} /> */}
                  <div className={css.wrapperContainer}>
                    <div className={css.cardsGridWrapper}>
                      {categories.map(category => (
                        <NamedLink
                          key={category}
                          name="SearchPage"
                          to={{ search: 'pub_category=' + category }}
                        >
                          <div className={css.categoryCard}>
                            {category === 'cameras' ? (
                              <CameraIcon />
                            ) : category === 'lenses' ? (
                              <LensIcon />
                            ) : category === 'audio' ? (
                              <AudioIcon />
                            ) : category === 'lighting' ? (
                              <LightingIcon />
                            ) : category === 'supports' ? (
                              <SupportIcon />
                            ) : category === 'drones' ? (
                              <DroneIcon />
                            ) : category === 'accessories' ? (
                              <AccessoriesIcon />
                            ) : category === 'locations' ? (
                              <LocationIcon />
                            ) : category === 'instruments' ? (
                              <InstrumentIcon />
                            ) : category === 'grips' ? (
                              <GripIcon />
                            ) : category === 'monitors' ? (
                              <Monitor />
                            ) : category === 'effects' ? (
                              <Effects />
                            ) : category === 'productionMaterial' ? (
                              <ProductionMaterial />
                            ) : null}
                            <span className={css.categoryTexts}>
                              <b>
                                {intl.formatMessage({
                                  id: `LandingPage.category.${category}Title`,
                                })}
                              </b>
                              <span className={css.categoryDescription}>
                                {intl.formatMessage({
                                  id: `LandingPage.category.${category}Description`,
                                })}
                              </span>
                            </span>
                          </div>
                        </NamedLink>
                      ))}
                    </div>
                  </div>
                  <div className={css.leftGradient}></div>
                  <div className={css.rightGradient}></div>
                </section>
                <Packs />
                <section>
                  <h3 className={css.sectionTitle}>
                    {intl.formatMessage({ id: 'LandingPage.section.mostPopularTitle' })}
                  </h3>
                  <h4 className={css.sectionDescription}>
                    {intl.formatMessage(
                      { id: 'LandingPage.section.mostPopularDescription' },
                      { isNearYou: false, location: 'España' }
                    )}
                  </h4>
                  <div className={css.wrapperContainer}>
                    <div className={css.cardsWrapper}>
                      {mostPopularListings.map(l => (
                        <ListingCard
                          className={css.listingCard}
                          key={l.id.uuid}
                          listing={l}
                          onToggleFavorites={onToggleFavorites}
                          currentUser={currentUser}
                        />
                      ))}
                    </div>
                  </div>
                </section>
              </Main>
              <Footer as="footer">
                <FooterComponent />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>

      {/*COMPONENTE COOKIE BANNER */}
      {/* <CookieConsent
        style={{
          width: '100%',
          display: 'flow-root list-item',
          backgroundColor: '#279d86',
          textAlign: 'center',
        }}
        location="bottom"
        buttonText="Aceptar cookies"
        buttonStyle={{
          backgroundColor: 'white',
          color: '#279d86',
          borderRadius: '24px',
          fontSize: '15px',
          margin: '15px 0',
        }}
        enableDeclineButton
        declineButtonText="Rechazar cookies"
        declineButtonStyle={{
          backgroundColor: 'white',
          color: '#e87655',
          borderRadius: '24px',
          fontSize: '15px',
          margin: '10px',
        }}
        cookieName="myCookieConsent"
        onDecline={handleRejectCookies}
        onAccept={handleAcceptCookies}
      >
        <h5 className={css.cookieText}>
          Usamos cookies para asegurar que te damos la mejor experiencia en nuestra web.
        </h5>
        <h5 className={css.cookieText}>
          Si continúas usando este sitio, asumiremos que estás de acuerdo con ello.
        </h5>
        <h5 className={css.linkCookiePolicy}>
          Más información en nuestra
          <NamedLink className={css.linkColorPolicy} name="CookiePolicyPage">
            {' '}
            Política de cookies
          </NamedLink>
        </h5>
      </CookieConsent> */}
      <CookieMananger />
    </StaticPage>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { currentPageResultIds, queryInProgress, queryPopularError } = state.LandingPage;
  const mostPopularListings = getListingsById(state, currentPageResultIds);
  const { currentUser } = state.user;

  // Example usage

  return {
    mostPopularListings,
    queryInProgress,
    queryPopularError,
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateFavorites: payload => dispatch(updateProfile(payload)),
});
// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LandingPageComponent);

export default LandingPage;

import Cookies from 'js-cookie';

const SaveCompanyToCookie = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const company = urlParams.get('company');

    if (company) {
      // Set cookie for 7 days
      Cookies.set('company', company, { expires: 7 });
      console.log('Company saved in cookies:', company);
    }
  }, []);

  return null; // No UI needed
};
